import type { GraphQLTypes, InputType } from '@zeus/index'
import { $, Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

/** Le compte de l'utilisateur connecté (#77), relu après chaque modification. */
const myAccountSelector = Selector('MyAccount')({
  id: true,
  firstName: true,
  lastName: true,
  email: true,
  username: true,
  role: true,
  organizationName: true,
  lastConnectionAt: true,
  hasPassword: true,
})

export type MyAccount = InputType<GraphQLTypes['MyAccount'], typeof myAccountSelector, typeof scalars>

export const GQL_MY_ACCOUNT = typedGql('query', { scalars })({
  myAccount: myAccountSelector,
})

export const GQL_UPDATE_MY_PROFILE = typedGql('mutation', { scalars })({
  updateMyProfile: [{ input: $('input', 'UpdateMyProfileInput!') }, myAccountSelector],
})

export const GQL_CHANGE_MY_PASSWORD = typedGql('mutation')({
  changeMyPassword: [
    { currentPassword: $('currentPassword', 'String!'), newPassword: $('newPassword', 'String!') },
    true,
  ],
})
